<template>
  <div class="border rounded-md px-3 py-4">
    <div class="flex justify-between mb-4 items-center space-x-4 border-b pb-2">
      <p class="text-xl font-light">Preview Class List</p>
      <button class="btn-xs text-sm btn-green" @click="generateClassList">Generate Preview</button>
    </div>
    <p class='mb-2 text-sm' v-for="(c, i) in generatedList" :key="i">
      {{`${i+1} - ${c.className}`}}
    </p>
  </div>
</template>

<script>
export default {
  props: {
    config: Object
  },
  data () {
    return {
      generatedList: []
    }
  },
  methods: {
    generateClassList () {
      this.axios.post(`${process.env.VUE_APP_ROOT_API}/generateClassList`, {config: this.config})
        .then(response => {
          this.generatedList = response.data.data
        })
    }
  }
}
</script>

<style>

</style>
